
import Vue, { ComponentOptions } from "vue";
import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch,
} from "vue-property-decorator";
import { cssStripe, getThemeColor } from "../palette";

@Component({
  filters: {},
})
export default class GenericPip extends Vue {
  @Prop({ type: String, default: "info" })
  public icon: string | null;

  @Prop({ type: String, default: null })
  public buttonIcon: string | null;

  @Prop({ type: String, default: "" })
  public buttonText: string;

  @Prop({ type: String, default: "primary" })
  public stripeColor: "" | "primary" | "accent" | "warn" | "transparent";

  @Prop({ type: String, default: "" })
  public cardClass: "" | "primary" | "accent" | "warn";

  @Prop({ type: Boolean, default: true })
  public hover: boolean;

  cssStripe = cssStripe;
  getThemeColor = getThemeColor;

  onClicked(event: any) {
    this.$emit("click");
  }
}
